/*const streamChatCompletion = async ({ authToken, messages, onToken }) => {
  const response = await fetch(`http://127.0.0.1:8000/rag`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({ question: messages }),
  });

  if (!response.ok) {
    throw new Error("Erreur API");
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let done = false;

  while (!done) {
    const { value, done: doneReading } = await reader.read();
    done = doneReading;

    const chunk = decoder.decode(value, { stream: true });
    const lines = chunk.split("\n");

    for (const line of lines) {
      if (!line.startsWith("data: ")) continue;

      const token = line.replace("data: ", "").trim();
      if (token === "[DONE]") return;

      // callback : envoie chaque token au composant React
      onToken(token);
    }
  }
}*/

const streamChatCompletion = async ({ authToken, messages, onToken }) => {
  const ai_api = "https://apigptpython-722786896605.europe-west1.run.app";
  //const ai_api = "http://localhost:8000";
  const response = await fetch(`${ai_api}/rag-stream`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({ messages }), // tableau de messages
  });

  if (!response.ok) throw new Error("Erreur API");

  const data = await response.json();
  // data.answer contient la réponse complète
  onToken(data.answer);
};

export { streamChatCompletion };

